@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <!-- Combined Header and Filter Section -->
    <div class="combined-header-filter-section" [ngClass]="{ 'dark-mode': selectedMode === 'dark' }">
      <!-- Header Content -->
      <div class="header-content">
        <div class="title-section">
          <div class="title-wrapper">
            <div class="title-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
            </div>
            <div class="title-text-container">
              <h1 class="main-title">Attendance Requests</h1>
              <p class="subtitle">Review and manage employee attendance requests</p>
            </div>
          </div>
        </div>
        
        <div class="action-buttons">
          @if (!isEditing) {
            <button type="button" class="modern-btn reports-btn" (click)="goToReports()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="20" x2="12" y2="10"></line>
                <line x1="18" y1="20" x2="18" y2="4"></line>
                <line x1="6" y1="20" x2="6" y2="16"></line>
              </svg>
              <span>Show Reports</span>
            </button>
            <button type="button" class="modern-btn bulk-edit-btn" (click)="editMode()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
              <span>Bulk Edit</span>
            </button>
          }
        </div>
      </div>
      
      <!-- Filter Toggle Button with Apply Button -->
      <div class="filter-toggle-section">
        <button class="filter-toggle-btn" (click)="toggleFilterSection()" [attr.aria-expanded]="isFilterExpanded">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="filter-icon">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
          <span>{{ isFilterExpanded ? 'Hide Filters' : 'Show Filters' }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="chevron-icon" [class.rotated]="isFilterExpanded">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        
        <button type="submit" form="form-link-outside-btn" class="control-btn apply-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          Apply Filters
        </button>
      </div>
      
      <form id="form-link-outside-btn" name="empForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
        <div class="filter-content" [@slideDown]="isFilterExpanded ? 'expanded' : 'collapsed'" *ngIf="isFilterExpanded">
          <div class="search-filters">
            <!-- Row 1: 4 Fields -->
            <div class="filter-row filter-row-four">
              <div class="input-group">
                <label>Search by Name</label>
                <div class="input-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="M21 21l-4.35-4.35"></path>
                  </svg>
                  <input type="text" name="name" placeholder="Search by name..." ngModel #name="ngModel" />
                </div>
              </div>
              
              <div class="input-group">
                <label>Start Date</label>
                <div class="input-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                  <input type="text" name="start_date" placeholder="Select start date" onfocus="(this.type='date')" onblur="(this.type='text')" ngModel #start_date="ngModel" />
                </div>
              </div>
              
              <div class="input-group">
                <label>End Date</label>
                <div class="input-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                  <input type="text" name="end_date" placeholder="Select end date" onfocus="(this.type='date')" onblur="(this.type='text')" ngModel #end_date="ngModel" />
                </div>
              </div>

              <div class="input-group">
                <label>Request Type</label>
                <div class="input-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                  </svg>
                  <select name="type" ngModel #type="ngModel">
                    <option value="" disabled selected>Search by Type</option>
                    <option value="check_in">Check In</option>
                    <option value="check_out">Check Out</option>
                    <option value="overtime">Over Time</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Row 2: 2 Fields -->
            <div class="filter-row filter-row-four">
              <div class="input-group">
                <label>Status</label>
                <div class="input-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                  </svg>
                  <select name="status" ngModel #status="ngModel">
                    <option value="" disabled selected>Search by Status</option>
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </div>
              </div>

              <div class="input-group">
                <label>Month</label>
                <div class="input-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                  </svg>
                  <select name="monthtype" ngModel #monthtype="ngModel">
                    <option value="" disabled selected>Search by Month</option>
                    <option value="curent_month">Current Month</option>
                    <option value="last_month">Last Month</option>
                  </select>
                </div>
              </div>
              
              <!-- Empty columns to maintain alignment -->
              <div class="input-group-empty"></div>
              <div class="input-group-empty"></div>
            </div>
          </div>
        </div>
      </form>
    </div>

          <!-- new -->
          @if (isEditing) {
            <div class="quick-action-section" [ngClass]="{ 'dark-mode': selectedMode === 'dark' }">
              <div class="quick-action-header">
                <div class="quick-action-title">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 11 12 14 22 4"></polyline>
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                  </svg>
                  <span>Quick Actions</span>
                  @if (countPending() != 0) {
                    <span class="pending-count">{{ countPending() }}</span>
                  }
                </div>
                
                <div class="quick-action-buttons">
                  <button type="button" class="action-btn cancel-action" (click)="cancelEdit()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M18 6 6 18"></path>
                      <path d="m6 6 12 12"></path>
                    </svg>
                    Cancel
                  </button>
                  
                  @if (isavailablefeature('isReject')) {
                    <button type="button" class="action-btn reject-all-action" data-toggle="modal" data-target="#rejectAll" (click)="getTextForAutomation()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m15 9-6 6"></path>
                        <path d="m9 9 6 6"></path>
                      </svg>
                      Reject All
                    </button>
                  }
                  
                  @if (isavailablefeature('isAccept')) {
                    <button type="button" class="action-btn approve-all-action" data-toggle="modal" data-target="#acceptAll">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                      </svg>
                      Approve All
                    </button>
                  }
                  
                  @if (isavailablefeature('isReject')) {
                    <button type="button" class="action-btn reject-selected-action" [disabled]="!anyCheckboxSelected()" data-toggle="modal" data-target="#reject" (click)="getTextForAutomation()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 6h18"></path>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                        <line x1="10" x2="10" y1="11" y2="17"></line>
                        <line x1="14" x2="14" y1="11" y2="17"></line>
                      </svg>
                      Reject Selected
                    </button>
                  }
                  
                  @if (isavailablefeature('isAccept')) {
                    <button type="button" class="action-btn approve-selected-action" [disabled]="!anyCheckboxSelected()" data-toggle="modal" data-target="#accept">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      Approve Selected
                    </button>
                  }
                </div>
              </div>
            </div>
          }
        <!-- new end -->

        <!-- approveall Modal -->
        <div class="modal fade" id="acceptAll" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <form #approve="ngForm" (ngSubmit)="aproveAll(approve)">
                <!-- ss -->
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h5 class="modal-title" id="updateModalLongTitle">
                    <img src="../../assets/images/authentication.png" alt="Missing image" />
                    Reason
                  </h5>
                </div>

                <div class="modal-body">
                  <div class="input-field-main">
                    <div class="col-md-10">
                      <div class="form-group">
                        <textarea class="form-control pl-4" id="" rows="3" name="reason" ngModel #updateReason="ngModel"
                        placeholder="Enter Reason*" required [(ngModel)]="reasonModal"></textarea>
                        @if (updateReason.valid && (updateReason.dirty || updateReason.touched)) {
                          <div>
                            @if (reasonModal !== undefined && reasonModal.trim().length < 50 ) {
                              <p
                                class="alert alert-warning mt-2">Ensure that the entered <strong>Reason</strong> contains a
                              minimum of 50 characters.</p>
                            }
                          </div>
                        }
                      </div>
                      <!-- automated text here -->
                      @if (acceptanceData.length > 0) {
                        <div>
                          <!-- <p>Automated Text</p> -->
                          @for (item of acceptanceData; track item) {
                            <div>
                              <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}</p>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="submit" class="btn btn-primary" [disabled]="approve.invalid ">Aprove All</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- Modal approve -->
        <div class="modal fade" id="accept" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <form #approve="ngForm" (ngSubmit)="slectedreq(approve)">
                <!-- ss -->
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h5 class="modal-title" id="updateModalLongTitle">
                    <img src="../../assets/images/authentication.png" alt="Missing image" />
                    Reason
                  </h5>
                </div>

                <div class="modal-body">
                  <div class="input-field-main">
                    <div class="col-md-10">
                      <div class="form-group">
                        <textarea class="form-control pl-4" id="" rows="3" name="reason" ngModel #updateReason="ngModel"
                        placeholder="Enter Reason*" required [(ngModel)]="reasonModal"></textarea>
                        @if (updateReason.valid && (updateReason.dirty || updateReason.touched)) {
                          <div>
                            @if (reasonModal !== undefined && reasonModal.trim().length < 50 ) {
                              <p
                                class="alert alert-warning mt-2">Ensure that the entered <strong>Reason</strong> contains a
                              minimum of 50 characters.</p>
                            }
                          </div>
                        }
                      </div>
                      <!-- automated text here -->
                      @if (acceptanceData.length > 0) {
                        <div>
                          <!-- <p>Automated Text</p> -->
                          @for (item of acceptanceData; track item) {
                            <div>
                              <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}</p>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="submit" class="btn btn-primary" [disabled]="approve.invalid ">Aprove</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- reject Modal munib -->
        <div class="modal fade" id="reject" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <form #approve="ngForm" (ngSubmit)="slectedrejectreq(approve)">
                <!-- ss -->
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h5 class="modal-title" id="updateModalLongTitle">
                    <img src="../../assets/images/authentication.png" alt="Missing image" />
                    Reason
                  </h5>
                </div>

                <div class="modal-body">
                  <div class="input-field-main">
                    <div class="col-md-10">
                      <div class="form-group">
                        <textarea class="form-control pl-4" id="" rows="3" name="reason" ngModel #updateReason="ngModel"
                        placeholder="Enter Reason*" required [(ngModel)]="reasonModal"></textarea>
                        @if (updateReason.valid && (updateReason.dirty || updateReason.touched)) {
                          <div>
                            @if (reasonModal !== undefined && reasonModal.trim().length < 50 ) {
                              <p
                                class="alert alert-warning mt-2">Ensure that the entered <strong>Reason</strong> contains a
                              minimum of 50 characters.</p>
                            }
                          </div>
                        }
                      </div>
                      <!-- automated text here -->
                      @if (RejectionData.length > 0) {
                        <div>
                          <!-- <p>Automated Text</p> -->
                          @for (item of RejectionData; track item) {
                            <div>
                              <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}</p>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="submit" [disabled]="approve.invalid " class="btn btn-danger">Reject</button>
                </div>
              </form>

            </div>
          </div>
        </div>
        <!-- reject All Modal munib -->
        <div class="modal fade" id="rejectAll" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <form #approve="ngForm" (ngSubmit)="rejectAll(approve)">
                <!-- ss -->
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h5 class="modal-title" id="updateModalLongTitle">
                    <img src="../../assets/images/authentication.png" alt="Missing image" />
                    Reason
                  </h5>
                </div>

                <div class="modal-body">
                  <div class="input-field-main">
                    <div class="col-md-10">
                      <div class="form-group">
                        <textarea class="form-control pl-4" id="" rows="3" name="reason" ngModel #updateReason="ngModel"
                        placeholder="Enter Reason*" required [(ngModel)]="reasonModal"></textarea>
                        @if (updateReason.valid && (updateReason.dirty || updateReason.touched)) {
                          <div>
                            @if (reasonModal !== undefined && reasonModal.trim().length < 50 ) {
                              <p
                                class="alert alert-warning mt-2">Ensure that the entered <strong>Reason</strong> contains a
                              minimum of 50 characters.</p>
                            }
                          </div>
                        }
                      </div>

                      <!-- automated text here -->
                      @if (RejectionData.length > 0) {
                        <div>
                          <!-- <p>Automated Text</p> -->
                          @for (item of RejectionData; track item) {
                            <div>
                              <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}</p>
                            </div>
                          }
                        </div>
                      }

                    </div>
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="submit" [disabled]="approve.invalid " class="btn btn-danger">Reject All</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- Modern Card-Based Attendance Request Listing -->
        <div class="attendance-requests-grid-container">
          @for (data of pagedAttendanceData; track data) {
            <div class="attendance-request-card" [ngClass]="{
              'card-approved': data.status === 'approved',
              'card-rejected': data.status === 'rejected',
              'card-pending': data.status === 'pending',
              'dark-card': selectedMode === 'dark'
            }">
              
              <!-- Card Header -->
              <div class="card-header-section">
                <div class="employee-info">
                  @if (data.status === 'pending' && isEditing) {
                    <div class="checkbox-wrapper">
                      <input type="checkbox" [(ngModel)]="data.isSelected" (change)="select(data.id)" class="styled-checkbox" />
                    </div>
                  }
                  
                  <div class="employee-avatar-text">
                    <ng-container *ngIf="data.user?.profile_image; else showInitials">
                      <img 
                        [src]="data.user.profile_image" 
                        alt="{{ data.user.first_name + ' ' + data.user.last_name }}" 
                        class="avatar-image"
                      />
                    </ng-container>
                    <ng-template #showInitials>
                      {{ getInitials(data.name) }}
                    </ng-template>
                  </div>
                  
                  <div class="employee-details">
                    <h3 class="employee-name">{{ data.name }}</h3>
                    <div class="request-meta">
                      <span class="meta-badge">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        {{ data.date }}</span>
                      <span class="meta-badge type-badge" [ngClass]="{
                        'checkin-badge': data.type === 'check_in',
                        'checkout-badge': data.type === 'check_out',
                        'overtime-badge': data.type === 'overtime'
                      }">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                          <polyline points="14 2 14 8 20 8"></polyline>
                        </svg>
                        {{ data.type | titlecase }}
                      </span>
                      <span class="meta-badge request-badge"  [ngClass]="{ 'high-sequence': data.monthly_sequence >= 3 }" *ngIf="data.monthly_sequence">
                        {{ getRequestNumberLabel(data.monthly_sequence) }}
                      </span>
                    </div>
                  </div>
                </div>
                
                <!-- Status Badge & Actions -->
                <div class="header-right-section">
                  <!-- Status Badge with different style -->
                  <div class="status-label-container">
                    <span class="status-label">Status:</span>
                    <div class="status-badge-new" [ngClass]="{
                      'status-approved': data.status === 'approved',
                      'status-rejected': data.status === 'rejected',
                      'status-pending': data.status === 'pending'
                    }">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        @if (data.status === 'approved') {
                          <polyline points="20 6 9 17 4 12"></polyline>
                        }
                        @if (data.status === 'rejected') {
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="15" y1="9" x2="9" y2="15"></line>
                          <line x1="9" y1="9" x2="15" y2="15"></line>
                        }
                        @if (data.status === 'pending') {
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="12" y1="8" x2="12" y2="12"></line>
                          <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        }
                      </svg>
                      {{ data.status | titlecase }}
                    </div>
                  </div>
                  
                  @if (data.status !== 'approved' && data.status !== 'rejected') {
                    <div class="action-buttons-compact">
                      @if (isavailablefeature('isAccept')) {
                        <button class="action-btn-compact btn-approve" data-toggle="modal" data-target="#updateModal" (click)="sendAcceptedData(data)">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                          Approve
                        </button>
                      }
                      @if (isavailablefeature('isReject')) {
                        <button class="action-btn-compact btn-reject" data-toggle="modal" data-target="#rejectupdateModal" (click)="sendRejectedData(data)">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                          </svg>
                          Reject
                        </button>
                      }
                    </div>
                  }
                </div>
              </div>
              
              <!-- Card Body - Two Column Layout -->
              <div class="card-body-section">
                <div class="content-two-column">
                  <!-- Left Column: Request Details -->
                  <div class="left-column">
                    <div class="details-compact">
                      <div class="detail-item-compact">
                        <div class="detail-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                          </svg>
                        </div>
                        <div class="detail-content-compact">
                          <span class="detail-label-compact">Old Value:</span>
                          <span class="detail-value-compact">{{ data.old_value }}</span>
                        </div>
                      </div>
                      
                      <div class="detail-item-compact">
                        <div class="detail-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                          </svg>
                        </div>
                        <div class="detail-content-compact">
                          <span class="detail-label-compact">Requested:</span>
                          @if (data.type === 'check_in') {
                            <span class="detail-value-compact">{{ data.check_in }}</span>
                          }
                          @if (data.type === 'check_out') {
                            <span class="detail-value-compact">{{ data.check_out }}</span>
                          }
                          @if (data.type === 'overtime') {
                            <span class="detail-value-compact">{{ data.overtime }}</span>
                          }
                        </div>
                      </div>
                      
                      @if (data.type === 'overtime' && data.check_in) {
                        <div class="detail-item-compact">
                          <div class="detail-icon">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                              <circle cx="12" cy="12" r="10"></circle>
                              <polyline points="12 6 12 12 16 14"></polyline>
                            </svg>
                          </div>
                          <div class="detail-content-compact">
                            <span class="detail-label-compact">Time Range:</span>
                            <span class="detail-value-compact">{{ data.check_in }} - {{ data.check_out }}</span>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  
                  <!-- Right Column: Reason Section -->
                  <div class="right-column">
                    <div class="description-section-compact">
                      <div class="description-header-compact">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                          <polyline points="14,2 14,8 20,8"></polyline>
                          <line x1="16" y1="13" x2="8" y2="13"></line>
                          <line x1="16" y1="17" x2="8" y2="17"></line>
                        </svg>
                        <span>Reason</span>
                      </div>
                      <p class="description-text-compact" [innerHTML]="data.reason"></p>
                    </div>
                  </div>
                </div>
                
                <!-- Admin Response Timeline Section -->
                @if (data.admin_reason !== null && data.admin_reason !== '') {
                  <div class="status-timeline-compact">
                    <div class="timeline-header-compact">
                      <div class="timeline-header-left">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                        </svg>
                        <span>Action Timeline</span>
                      </div>
                    </div>
                    
                    <div class="timeline-items-compact">
                      <div class="timeline-item-compact" [ngClass]="{
                        'timeline-approved': data.status === 'approved',
                        'timeline-rejected': data.status === 'rejected'
                      }">
                        <div class="timeline-marker-compact">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            @if (data.status === 'approved') {
                              <polyline points="20 6 9 17 4 12"></polyline>
                            }
                            @if (data.status === 'rejected') {
                              <circle cx="12" cy="12" r="10"></circle>
                              <line x1="15" y1="9" x2="9" y2="15"></line>
                              <line x1="9" y1="9" x2="15" y2="15"></line>
                            }
                          </svg>
                        </div>
                        <div class="timeline-content-compact">
                          <div class="timeline-admin-info">
                            <div class="timeline-admin-avatar">
                              <img [src]="data.admin.profile_image ? data.admin.profile_image : 'assets/images/question.jpg'" alt="Admin" />
                            </div>
                            <div class="timeline-admin-details">
                              <div class="timeline-admin-name">{{ data.admin.first_name }} {{ data.admin.last_name }}</div>
                              <div class="timeline-action">{{ data.status === 'approved' ? 'Approved' : 'Rejected' }} this request</div>
                            </div>
                          </div>
                          <div class="timeline-date">{{ data.updated_at | date:'MMM dd, yyyy' }}</div>
                          <button class="info-btn-timeline" data-toggle="modal" data-target="#attreason" (click)="detailAdmin(data)">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="M12 16v-4"></path>
                              <path d="M12 8h.01"></path>
                            </svg>
                            View Full Details
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
        
        <!-- Paginator -->
        @if (attendanceRequest) {
          <mat-paginator [ngClass]="{ 'dark-tr-main': selectedMode === 'dark' }"
            [length]="attendanceRequest.length" [pageSize]="pageSize" (page)="onPageChange($event)" style="margin-top: 20px; border-radius: 12px;">
          </mat-paginator>
        }

              <!-- modal for admin i -->
              <div class="modal fade" id="attreason" tabindex="-1" role="dialog" aria-labelledby="attreasonLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                  <div class="modal-content ">
          <div class="modal-header1 " [ngClass]="{
          'approve-reason-head': Admin_detail.status === 'approved',
          'reject-reason-head': Admin_detail.status === 'rejected'
        }">
                      <h5 class="modal-title1" id="attreasonLabel">Reason</h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body info-modal-body">
                      <div class="row">
                        <div class="col-12">
                          <div class="modal-image reason-image">
                            <img
                              [src]="'../../../assets/theme1/' + (Admin_detail.status  === 'approved' ? 'green.png' : 'reason-modal.png')"
                              alt="Missing icon" />
                              <!-- <h1 *ngif="item.status === 'approved'">Your Request is Approved?</h1>
                              <h1 *ngif="item.status === 'rejected'">Why Your Request is Rejected?</h1> -->

                            </div>
                          </div>
                          <div class="col-4 p-0">
                <div class="col-head reason-head1" [ngClass]="{
                'reason-head-bgcolor-approve': Admin_detail.status === 'approved',
                'reason-head-bgcolor-reject': Admin_detail.status === 'rejected'
              }">
                              Admin
                            </div>
                          </div>
                          <div class="col-8 p-0">
                            <div class="col-data reason-body admin-name-dep">
                              {{Admin_detail.admin.first_name}} {{ Admin_detail.admin.last_name }}
                              <span>{{Admin_detail.admin.department}} </span>
                            </div>
                          </div>
                          <div class="col-4 p-0">
                <div class="col-head reason-head1" [ngClass]="{
                'reason-head-bgcolor-approve': Admin_detail.status === 'approved',
                'reason-head-bgcolor-reject': Admin_detail.status === 'rejected'
              }">
                              Status
                            </div>
                          </div>
                          <div class="col-8 p-0">
                            <div class="col-data reason-body ">
                              <!-- <img src="../../../assets/theme1/cross-icon.png" alt="Missing icon"> -->
                              {{Admin_detail.status |titlecase}}
                            </div>
                          </div>
                          <div class="col-4 p-0">
                <div class="col-head reason-head1" [ngClass]="{
                'reason-head-bgcolor-approve': Admin_detail.status === 'approved',
                'reason-head-bgcolor-reject': Admin_detail.status === 'rejected'
              }">
                              Action Date
                            </div>
                          </div>
                          <div class="col-8 p-0">
                            <div class="col-data reason-body">
                              {{Admin_detail.updated_at | date:'MMM dd, yyyy'}}
                            </div>
                          </div>
                          <div class="col-4 p-0">
                <div class="col-head description-body reason-head1" [ngClass]="{
                'reason-head-bgcolor-approve': Admin_detail.status === 'approved',
                'reason-head-bgcolor-reject': Admin_detail.status === 'rejected'
              }">
                              Reason
                            </div>
                          </div>
                          <div class="col-8 p-0">
                            <div class="col-data description-body reason-body">
                              {{Admin_detail.admin_reason}}
                            </div>
                          </div>


                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <!-- Button trigger modal -->
                <!-- Modal -->
                <div class="modal fade" id="updateModal" tabindex="-1" role="dialog" aria-labelledby="updateModalCenterTitle"
                  aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-dialog-xl" role="document">
                    <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                      <form #attendance="ngForm" (ngSubmit)="aproveReq(attendance)">
                        <div class="modal-header">

                          <h5 class="modal-title" id="updateModalLongTitle">
                            Reason
                          </h5>
                        </div>

                        <div class="modal-body">
                          <div class="input-field-main">
                            <div class="col-md-10">
                              <div class="form-group">
                                <textarea class="form-control pl-4" id="" rows="3" name="reason" ngModel #updateReason="ngModel"
                                placeholder="Enter Reason*" required [(ngModel)]="reasonModal"></textarea>
                                @if (updateReason.valid && (updateReason.dirty || updateReason.touched)) {
                                  <div>
                                    @if (reasonModal !== undefined && reasonModal.trim().length < 50 ) {
                                      <p
                                        class="alert alert-warning mt-2">Ensure that the entered <strong>Reason</strong> contains a
                                      minimum of 50 characters.</p>
                                    }
                                  </div>
                                }
                              </div>
                              <!-- automated text here -->
                              @if (acceptanceData.length > 0) {
                                <div>
                                  <!-- <p>Automated Text</p> -->
                                  @for (item of acceptanceData; track item) {
                                    <div>
                                      <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}</p>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </div>

                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-dismiss="modal">

                            Close
                          </button>
                              <button type="submit" class="btn btn-primary" [disabled]="
                              attendance.invalid || (reason !== undefined && reason.trim().length < 50)
                            ">
                            Approve
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <!-- end -->
                <!-- Button trigger modal -->
                <!-- Modal -->

                <div class="modal fade" id="rejectupdateModal" tabindex="-1" role="dialog"
                  aria-labelledby="rejectupdateModalCenterTitle" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-dialog-xl" role="document">
                    <div class="modal-content">
                      <form #attendance="ngForm" (ngSubmit)="rejectReq(attendance)">
                        <div class="modal-header">
                          <h5 class="modal-title" id="updateModalLongTitle">
                            Attendance Request Reject
                          </h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>

                        <div class="modal-body">
                          <div class="attendance-body-head">
                            <img src="../../assets/images/authentication.png" alt="Missing image" />
                          </div>
                          <div class="input-field-main">
                            <div class="col-md-12">
                              <div class="form-group">
                                <textarea class="form-control modal-text-area pl-4" id="reason1" rows="3" name="reason1"
                                [(ngModel)]="reason1" #updateReason="ngModel" placeholder="Enter Reason*" required></textarea>
                                @if (
                                  updateReason.valid &&
                                  (updateReason.dirty || updateReason.touched)
                                  ) {
                                  <div>
                                    @if (reason1.trim().length < 50) {
                                      <p class="alert alert-warning mt-2">
                                        Ensure that the entered <strong>Reason</strong> contains a minimum of 50 characters.
                                      </p>
                                    }
                                  </div>
                                }
                              </div>
                              @if (RejectionData.length > 0) {
                                <div>
                                  <!-- <p>Automated Text</p> -->
                                  @for (item of RejectionData; track item) {
                                    <div>
                                      <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}</p>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </div>

                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Close
                          </button>
                          <button type="submit" class="btn btn-primary"
                          [disabled]="!reason1.trim() || reason1.trim().length < 50">Rejected</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <!-- end -->
              </div>
            </main>